import HeaderCalculator from "../../components/HeadrCalculator";
import { MessageError } from "../../components/MessageError";
import PayamentMP from "../../components/PayamentMP";

export default function PagePayment(props) {
  const {
    statusMode,
    setStatusMode,
    isLoggedIn,
    showLogoutButton,
  } = props;
  return (
    <>
      <HeaderCalculator
        statusMode={statusMode}
        setStatusMode={setStatusMode}
        isLoggedIn={isLoggedIn}
        showLogoutButton={showLogoutButton}
      />

      {isLoggedIn === true ? (
        <PayamentMP />
      ) : (
        <MessageError
          message={
            "Ops! Para acessar esta página e realizar o pagamento, é necessário fazer login."
          }
        />
      )}
    </>
  );
}
